var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "modal",
    attrs: { "modal-dialog-size": "md" },
    on: { show: _vm.handleShow, hide: _vm.handleHide },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("templates.actions.createTemplate")) +
                "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("p", { staticClass: "justified progress-text" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("templates.modals.createSubtitle")) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c("material-input", {
              staticClass: "position-relative",
              attrs: {
                id: "name",
                "on-type": "",
                name: "name",
                label: _vm.$t("templates.templateName"),
              },
              on: { enter: _vm.handleCreate },
              model: {
                value: _vm.name,
                callback: function ($$v) {
                  _vm.name = $$v
                },
                expression: "name",
              },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "simple-button",
              {
                attrs: {
                  disabled: _vm.createButtonDisabled,
                  loading: _vm.loading,
                  "loading-succeeded": _vm.createSucceeded,
                },
                on: { click: _vm.handleCreate },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("templates.actions.createTemplate")) +
                    "\n    "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }